import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from 'styleguide';

import IconClose from 'icons/Close';
import IconPhoto from 'icons/Photo';
import IconVideo from 'icons/Video';
import IconEdit from 'icons/Edit';
import IconPlay from 'icons/Play';

import CloseButton from 'styled/Buttons/CloseButton';
import Price from 'styled/Price';

import Title from './Title';
import CloseLink from './CloseLink';
import Header from './Header';
import GrayTxt from './GrayTxt';
import PriceContainer from './PriceContainer';
import Description from './Description';
import Duration from './Duration';

function durationFormat(duration) {
  function zeroCheck(inputNumber) {
    if (inputNumber < 10) return `0${inputNumber}`;

    return inputNumber;
  }

  const h = Math.floor(duration / 3600);
  const temp1 = Math.floor(duration) - (h * 3600);
  const m = Math.floor(temp1 / 60);
  const s = Math.floor(temp1) % 60;

  return `${zeroCheck(h)}:${zeroCheck(m)}:${zeroCheck(s)}`;
}

export function MaterialHeaderInfo(props) {
  return (
    <Header>
      {props.createdAt && (
        <GrayTxt>
          {new Date(props.createdAt).toLocaleString('ru-RU', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'Europe/Moscow',
          })}
        </GrayTxt>
      )}

      {props.mediaType === 'video' && (
        <Duration>
          <IconPlay />
          <span>
            {durationFormat(props.duration)}
          </span>
        </Duration>
      )}

      <Title>
        {props.mediaType === 'image' &&
        <IconPhoto color={COLORS.gray40} />
        }

        {props.mediaType === 'video' &&
        <IconVideo color={COLORS.gray40} />
        }

        <span style={{ paddingLeft: '15px' }}>{props.title || '-'}</span>
      </Title>

      <Description>
        {props.description.split('\n').map((item, index) => (
          <span key={item + index}>{item}<br /></span> // eslint-disable-line react/no-array-index-key
        ))}
        {!props.description && '-'}
      </Description>

      <PriceContainer>
        {Number(props.price) > 0
          ? (<Price>{props.price}</Price>)
          : 'Цена не проставлена'
        }
      </PriceContainer>

      {props.backPath
        ? (<CloseLink to={props.backPath}><IconClose /></CloseLink>)
        : (
          <CloseButton onClick={props.onMaterialClose}>
            <IconClose />
          </CloseButton>
        )
      }

      <CloseButton
        onClick={props.onEditClick}
        type="button"
        style={{ right: '25px', padding: '0 5px' }}
      >
        <IconEdit />
      </CloseButton>
    </Header>
  );
}

MaterialHeaderInfo.propTypes = {
  title: PropTypes.string,
  mediaType: PropTypes.oneOf(['video', 'image']),
  description: PropTypes.string,
  createdAt: PropTypes.number,
  duration: PropTypes.number,
  price: PropTypes.number,
  onMaterialClose: PropTypes.func,
  onEditClick: PropTypes.func,
  backPath: PropTypes.string,
};

MaterialHeaderInfo.defaultProps = {
  title: '',
  mediaType: 'image',
  description: '',
  createdAt: undefined,
  duration: 0,
  price: 0,
  onMaterialClose: () => {},
  onEditClick: () => {},
  backPath: '',
};

export default MaterialHeaderInfo;
